// extracted by mini-css-extract-plugin
export default {"modal_body_wrapper":"successCreateEvent_modal_body_wrapper__oenuT","modal_body":"successCreateEvent_modal_body__ZR4A+","btns":"successCreateEvent_btns__JvvM7"};